import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';
import { useAuth } from '../../lib/AuthContext';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  useEffect(() => {
    // Redirect if already logged in
    if (isAuthenticated) {
      navigate('/admin/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await login({ username, password });
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="max-w-md w-full bg-surface rounded-xl shadow-elevation-3 p-8">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <div className="w-10 h-10 bg-gradient-to-br from-accent to-warning rounded-lg flex items-center justify-center">
              <span className="text-surface font-heading font-bold text-lg">P</span>
            </div>
            <h3 className="font-heading font-bold text-xl">Portfolio Admin</h3>
          </div>
          <h1 className="font-heading text-2xl font-bold text-primary mb-2">Admin Login</h1>
          <p className="font-body text-text-secondary">Sign in to manage your portfolio</p>
        </div>

        {error && (
          <div className="bg-error/10 border border-error/30 text-error rounded-lg p-4 mb-6 flex items-center">
            <Icon name="AlertCircle" size={20} className="mr-2 flex-shrink-0" />
            <p className="text-sm">{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="username" className="block font-body font-medium text-primary mb-2">
              Username
            </label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary/30 focus:border-primary outline-none transition-all duration-200 font-body"
              required
            />
          </div>

          <div>
            <label htmlFor="password" className="block font-body font-medium text-primary mb-2">
              Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 border border-border rounded-lg focus:ring-2 focus:ring-primary/30 focus:border-primary outline-none transition-all duration-200 font-body"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-primary text-surface py-3 rounded-lg font-body font-medium hover:bg-primary/90 transition-colors duration-200 flex items-center justify-center"
          >
            {loading ? (
              <span className="flex items-center">
                <Icon name="Loader" size={20} className="animate-spin mr-2" />
                Signing in...
              </span>
            ) : (
              'Sign In'
            )}
          </button>
        </form>

        <div className="mt-8 text-center">
          <button
            onClick={() => navigate('/')}
            className="font-body text-text-secondary hover:text-primary transition-colors duration-200 text-sm flex items-center justify-center mx-auto"
          >
            <Icon name="ArrowLeft" size={16} className="mr-1" />
            Back to Portfolio
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin; 